import React from 'react';
import { Box, Grid, Typography, useTheme } from '@mui/material';
import HoverLink from '../HoverLink';

const Footer: React.FC = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box component="footer" color={theme.palette.text.primary} p={4} sx={{ pt: 8, contentVisibility: 'auto', containIntrinsicSize: '1px 700px' }}>
      <Grid container spacing={4} justifyContent="space-between" alignItems="center">
        <Grid item xs={12} md={3}>
          <Box
            component="img"
            src="/logos/logo_white_smooth.svg"
            loading="lazy"
            decoding="async"
            fetchPriority="low"
            alt="Логотип компании"
            sx={{
              height: { xs: '120px', sm: '140px', md: '160px' },
              objectFit: 'contain',
              filter: theme.palette.mode === 'dark' ? 'brightness(1)' : 'brightness(0)',
            }}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <HoverLink
              to="/catalog"
              label="Каталог"
              underlineColor={theme.palette.text.primary}
              color="inherit"
              variant="body1"
              sx={{ fontSize: '20px', mb: 2, maxWidth: 'fit-content' }}
            />
            <HoverLink
              to="/company"
              label="Компания"
              underlineColor={theme.palette.text.primary}
              color="inherit"
              variant="body1"
              sx={{ fontSize: '20px', mb: 2, maxWidth: 'fit-content' }}
            />
            <HoverLink
              to="/contacts"
              label="Контакты"
              underlineColor={theme.palette.text.primary}
              color="inherit"
              variant="body1"
              sx={{ fontSize: '20px', mb: 2, maxWidth: 'fit-content' }}
            />
            <HoverLink
              to="/how-to-buy"
              label="Доставка и оплата"
              underlineColor={theme.palette.text.primary}
              color="inherit"
              variant="body1"
              sx={{ fontSize: '20px', mb: 2, maxWidth: 'fit-content' }}
            />
            <HoverLink
              to="/returns"
              label="Возврат и претензии"
              underlineColor={theme.palette.text.primary}
              color="inherit"
              variant="body1"
              sx={{ fontSize: '20px', mb: 2, maxWidth: 'fit-content' }}
            />
            <HoverLink
              to="https://yuzhen.store/blog/"
              label="Блог"
              underlineColor={theme.palette.text.primary}
              color="inherit"
              variant="body1"
              sx={{ fontSize: '20px', mb: 2, maxWidth: 'fit-content' }}
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={3}>
          <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
            Телефон представителя в Шанхае:
          </Typography>
          <Box sx={{ mb: 2 }}>
            <HoverLink
              to="tel:+8615502106310"
              label="+86 155-021-063-10"
              underlineColor={theme.palette.text.primary}
              color="inherit"
              variant="body1"
            />
          </Box>

          <Typography variant="body1" sx={{ fontWeight: 'bold', mt: 2 }}>
            Телефон в РФ:
          </Typography>
          <Box>
            <HoverLink
              to="tel:+79109351152"
              label="+7 910 935-11-52"
              underlineColor={theme.palette.text.primary}
              color="inherit"
              variant="body1"
            />
          </Box>

          <Typography variant="body1" sx={{ fontWeight: 'bold', mt: 2 }}>
            Email:
          </Typography>
          <Box>
            <HoverLink
              to="mailto:2608197979@mail.ru"
              label="2608197979@mail.ru"
              underlineColor={theme.palette.text.primary}
              color="inherit"
              variant="body1"
            />
          </Box>
        </Grid>
      </Grid>

      <Typography variant="body2" color="textSecondary" align="center" sx={{ mt: 2 }}>
        © {currentYear} Yuzhen. Все права защищены.
      </Typography>

      <Typography
        variant="caption"
        color="textSecondary"
        align="center"
        sx={{
          mt: 2,
          display: 'block',
          maxWidth: '100%',
          px: 2,
        }}
      >
        Вы принимаете условия{' '}
        <HoverLink
          to="/privacy"
          label="политики в отношении обработки персональных данных"
          color="textSecondary"
          variant="caption"
        />{' '}
        и{' '}
        <HoverLink
          to="/agreement"
          label="пользовательского соглашения"
          color="textSecondary"
          variant="caption"
        />{' '}
        каждый раз, когда оставляете свои данные в любой форме обратной связи на сайте{' '}
        <HoverLink
          to="https://yuzhen.store/"
          label="https://yuzhen.store/"
          color="textSecondary"
          variant="caption"
        />
      </Typography>

      <Typography
        variant="caption"
        color="textSecondary"
        align="center"
        sx={{
          mt: 1,
          display: 'block',
          maxWidth: '100%',
          px: 2,
        }}
      >
        Информация о товарах, ценах и условиях, размещенная на сайте, носит информационный характер.
        Окончательные условия заказа, наличие товара, стоимость, сроки и условия поставки уточняются
        продавцом при подтверждении заказа.
      </Typography>
    </Box>
  );
};

export default Footer;
